// Shared blob-download helpers — the single home for Content-Disposition
// filename parsing and the anchor-click download dance, used by the upload,
// PAA, and history flows alike.

/** Extract the download filename from a Content-Disposition header, preferring
 *  the RFC 5987 `filename*=UTF-8''…` form over the plain quoted form. */
export function parseFilenameFromHeader(header: string | null): string | null {
  if (!header) return null;
  const ext = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (ext?.[1]) {
    try {
      return decodeURIComponent(ext[1]);
    } catch {
      /* fall through */
    }
  }
  const std = /filename="?([^"]+)"?/i.exec(header);
  return std?.[1] ?? null;
}

/** Download a Blob via a temporary object URL + anchor click. */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
